/* ══════════════════════════════════════════════════════════════════
   OTTR — shop card behaviour.

   Two jobs, both delegated from the document so a card added by the
   theme editor, by a section reload, or by any later markup works
   without being re-wired:

     1. the swipe gallery on every .oshop-gal
     2. quick add-to-cart on .qa-cart

   The gallery does NOT animate anything itself. scroll-snap moves the
   track; this only reads scrollLeft to light the right dot and disable
   the right arrow. That keeps touch, trackpad, wheel and keyboard all
   behaving identically, and means nothing has to be recomputed on
   resize or on a breakpoint change.

   The quick-add half is the same flow blocks/ottr-shelf.liquid used to
   carry as an inline script. Both guard on window.__ottrQaWired, so
   whichever arrives first binds and the other stands down — no double
   add on one click.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.__ottrShopWired) return;
  window.__ottrShopWired = true;

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function smooth() { return RM && RM.matches ? 'auto' : 'smooth'; }

  /* ── 1 · the gallery ─────────────────────────────────────────────── */

  function sync(gal) {
    var track = gal.querySelector('.oshop-track');
    var dots = gal.querySelectorAll('.oshop-dots i');
    if (!track || dots.length < 2) return;
    var prev = gal.querySelector('.oshop-nav--p');
    var next = gal.querySelector('.oshop-nav--n');
    var w = track.clientWidth || 1;
    var n = dots.length;
    var i = Math.round(track.scrollLeft / w);
    if (i < 0) i = 0;
    if (i > n - 1) i = n - 1;
    for (var k = 0; k < n; k++) dots[k].classList.toggle('on', k === i);
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === n - 1;
  }

  function go(gal, step) {
    if (!gal) return;
    var t = gal.querySelector('.oshop-track');
    if (!t) return;
    t.scrollBy({ left: step * t.clientWidth, behavior: smooth() });
  }

  /* scroll → repaint the dots, once per frame. Capture phase, because a
     scroll event does not bubble. */
  var pending = false;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('oshop-track')) return;
    var gal = t.closest('.oshop-gal');
    if (!gal || pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; sync(gal); });
  }, true);

  /* arrows */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.oshop-nav') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    go(btn.closest('.oshop-gal'), btn.classList.contains('oshop-nav--n') ? 1 : -1);
  });

  /* keyboard, once the track has focus */
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('oshop-track')) return;
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    go(t.closest('.oshop-gal'), e.key === 'ArrowRight' ? 1 : -1);
  });

  /* pointer drag, so a mouse or trackpad feels like a thumb. Touch is
     left alone — the native gesture beats anything re-implemented. */
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch') return;
    var t = e.target.closest ? e.target.closest('.oshop-track') : null;
    if (!t) return;
    drag = { t: t, x: e.clientX, s: t.scrollLeft, moved: false };
    t.style.scrollBehavior = 'auto';
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var d = e.clientX - drag.x;
    if (Math.abs(d) > 3) drag.moved = true;
    drag.t.scrollLeft = drag.s - d;
  });
  function release() {
    if (!drag) return;
    var t = drag.t;
    var moved = drag.moved;
    drag = null;
    t.style.scrollBehavior = '';
    var w = t.clientWidth || 1;
    t.scrollTo({ left: Math.round(t.scrollLeft / w) * w, behavior: smooth() });
    if (moved) {
      t.__ottrJustDragged = true;
      setTimeout(function () { t.__ottrJustDragged = false; }, 80);
    }
  }
  document.addEventListener('pointerup', release);
  document.addEventListener('pointercancel', release);

  /* a drag must not also follow the card's link */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.oshop-track') : null;
    if (t && t.__ottrJustDragged) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('.oshop-track')) e.preventDefault();
  });

  function armAll() {
    var gals = document.querySelectorAll('.oshop-gal');
    for (var i = 0; i < gals.length; i++) sync(gals[i]);
  }

  /* ── 2 · quick add to cart ────────────────────────────────────────── */

  if (!window.__ottrQaWired) {
    window.__ottrQaWired = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.qa-cart') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          var c = btn.querySelector('.qa-count');
          if (c) {
            c.textContent = (parseInt(c.textContent, 10) || 0) + 1;
            c.hidden = false;
          }
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 550);
          document.dispatchEvent(new CustomEvent('cart:updated'));
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          var badge = document.querySelector('.icons .cart b');
          if (badge) badge.textContent = cart.item_count;
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-failed');
          setTimeout(function () { btn.classList.remove('is-failed'); }, 1200);
        });
    });
  }

  /* ── boot ────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armAll);
  } else {
    armAll();
  }
  /* Tinker hydrates after first paint and the editor re-runs sections */
  document.addEventListener('shopify:section:load', armAll);
  setTimeout(armAll, 600);
  setTimeout(armAll, 2200);
})();
